import { Button } from 'antd';
import { DataSecurityApplicationStatus } from '@sonar-software/sonar-core';
import { getQueryString } from '@sonar-software/sonar-http';
import { Link } from 'react-router-dom';
import React from 'react';

import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { useApplicationReference, useCurrentUser } from '@hooks';

export interface MonitorAppButtonProps {
	applicationId: number;
	type?: 'primary' | 'default';
}

export const MonitorAppButton: React.FC<MonitorAppButtonProps> = ({ applicationId, type = 'primary' }) => {
	const { status } = useApplicationReference(applicationId);
	const { isReadOnly } = useCurrentUser();

	const isDetected = status === DataSecurityApplicationStatus.Detected;

	if (!isDetected || isReadOnly) {
		return null;
	}

	return (
		<Link to={ `${FULL_ROUTES.ADD_APP}?${getQueryString({ applicationId })}` }>
			<Button type={ type }>{ COPY_SPECIFIC.MONITOR_APP }</Button>
		</Link>
	);
};
